/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { UserModel } from './userModel';

export class AdminModel extends UserModel {

  constructor() {
    super();
  }
}
